import { createEffect, createEvent, createStore } from 'effector';
import { Workspace } from '@nx-frontend/shared/types';

export interface WsFirstVisit {
  [key: string]: boolean;
}

export const lsWsFirstVisitKey = 'ws-first-visit';

export const initialWorkspacesState: Workspace[] = [];
export const addWorkspaceToStoreEvent = createEvent<Workspace>();

export const $workspaces = createStore(initialWorkspacesState).on(addWorkspaceToStoreEvent, (store, newWorkspace) => {
  const index = store.findIndex(({ globalId }) => globalId === newWorkspace.globalId);
  if (index > -1) {
    return store;
  }
  return [...store, newWorkspace];
});

export const $workspacesIds = $workspaces.map((workspaces) => workspaces.map((workspace) => workspace.globalId));

export const getWsFirstVisitFx = createEffect((workspaceId: string) => {
  const lsValue = localStorage.getItem(lsWsFirstVisitKey) || '{}';
  const wsFirstVisit = JSON.parse(lsValue) as WsFirstVisit;

  return { isFirstVisit: Boolean(wsFirstVisit[workspaceId]), wsFirstVisit };
});

export const setWsFirstVisitFx = createEffect((wsFirstVisit: WsFirstVisit) => {
  localStorage.setItem(lsWsFirstVisitKey, JSON.stringify(wsFirstVisit));
});
